import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'SSL Certificate',
  slug: 'ssl-certificate',
  definition: `An SSL (Secure Sockets Layer) certificate is a digital credential that enables encrypted communication between a web browser and a server. When you see the padlock icon and "https://" in your browser, an SSL certificate is making that possible.

SSL certificates serve two purposes: encryption and trust. They encrypt data in transit so it cannot be intercepted, and they verify that the server you are connecting to is who it claims to be. The modern version of the protocol is actually TLS (Transport Layer Security), but the term SSL is still widely used.

Certificates are issued by Certificate Authorities (CAs) and have expiration dates, typically 90 days for Let's Encrypt or up to 1 year for commercial certificates. An expired certificate causes browsers to display scary warning pages, effectively making your site inaccessible.`,
  whyItMatters: `An expired SSL certificate is one of the most common and preventable causes of apparent downtime. Users see a full-page browser warning and most will not proceed past it. Your server is running fine, but nobody can reach it.

Beyond availability, SSL certificates affect SEO. Search engines give ranking preference to HTTPS sites, and Chrome marks HTTP sites as "Not Secure." For any production website, SSL is not optional.`,
  howUptrackHelps: `Uptrack's HTTPS checks verify that your SSL certificate is valid as part of every monitoring cycle. If your certificate expires or is misconfigured, Uptrack detects the failure on the next check and alerts you once several locations confirm it.

This gives you advance warning before users start seeing browser warnings, letting you renew the certificate and restore trust before it impacts traffic.`,
  relatedTerms: [
    { name: 'DNS Propagation', href: '/glossary/dns-propagation' },
    { name: 'Downtime', href: '/glossary/downtime' },
    { name: 'Latency', href: '/glossary/latency' },
    { name: 'Uptime', href: '/glossary/uptime' },
  ],
}

export const Route = createFileRoute('/_site/glossary/ssl-certificate')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
